export default "__VITE_ASSET__51fecc24__"